import '../shared'

import SettingsService from 'live/services/settings'
import AdminSettings from './AdminSettings'


SettingsService.register(AdminSettings)